import { useEffect, useRef, useState } from 'react'
import { GraduationCap, Menu, X } from 'lucide-react'
import logo from '../assets/img/olan-academic.png'

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)
  const navRef = useRef(null)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollTo = (id) => {
    setMobileOpen(false)
    const el = document.getElementById(id)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const navLinks = [
    { label: 'Inicio', id: 'hero' },
    { label: 'Beneficios', id: 'beneficios' },
    { label: 'Módulos', id: 'modulos' },
    { label: 'Solicitar', id: 'solicitar-demo' },
  ]

  return (
    <>
      <nav
        ref={navRef}
        className="fixed top-0 left-0 w-full z-[100] transition-all duration-300"
        style={{
          height: 72,
          backgroundColor: scrolled ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.95)',
          backdropFilter: scrolled ? 'blur(12px)' : 'none',
          borderBottom: scrolled ? '1px solid rgba(0,0,0,0.05)' : '1px solid transparent',
          boxShadow: scrolled ? '0 1px 3px rgba(0,0,0,0.05)' : 'none',
        }}
      >
        <div className="container-main h-full flex items-center justify-between">
          <button
            onClick={() => scrollTo('hero')}
            className="flex items-center gap-2 cursor-pointer"
          >
            {/* <div
              className="flex items-center justify-center rounded-full"
              style={{ width: 32, height: 32, backgroundColor: '#10B981' }}
            >
              <GraduationCap size={18} color="white" strokeWidth={2.5} />
            </div> */}
            <span
              className="font-bold text-xl"
              style={{ color: scrolled ? '#0F293E' : '#FFFFFF' }}
            >
              <img src={logo} alt="Olan Academic" className="w-auto h-12" />
            </span>
          </button>

          {/* <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="relative text-sm font-medium cursor-pointer group"
                style={{ color: scrolled ? '#4B5563' : 'rgba(255,255,255,0.8)' }}
              >
                {link.label}
                <span
                  className="absolute left-0 bottom-[-4px] h-[2px] bg-[#10B981] transition-transform duration-300 origin-center group-hover:scale-x-100"
                  style={{ width: '100%', transform: 'scaleX(0)' }}
                />
                <style>{`
                  .group:hover span {
                    transform: scaleX(1) !important;
                  }
                `}</style>
              </button>
            ))}
          </div> */}

          {/* <button
            onClick={() => scrollTo('solicitar-demo')}
            className="hidden md:block btn-primary"
            style={{ padding: '10px 22px', fontSize: '14px' }}
          >
            Cotizar Ahora
          </button> */}

          {/* <button
            onClick={() => setMobileOpen(true)}
            className="md:hidden cursor-pointer"
            style={{ color: scrolled ? '#0F293E' : 'white' }}
          >
            <Menu size={28} />
          </button> */}
        </div>
      </nav>

      {mobileOpen && (
        <div className="fixed inset-0 z-[200] md:hidden">
          <div
            className="absolute inset-0"
            style={{ backgroundColor: 'rgba(15,41,62,0.5)' }}
            onClick={() => setMobileOpen(false)}
          />
          <div
            className="absolute right-0 top-0 h-full w-[280px] bg-white shadow-xl flex flex-col"
          >
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <span className="font-bold text-lg text-[#0F293E]">Olan Academic</span>
              <button onClick={() => setMobileOpen(false)} className="cursor-pointer">
                <X size={24} color="#0F293E" />
              </button>
            </div>
            {/* <div className="flex flex-col py-4">
              {navLinks.map((link) => (
                <button
                  key={link.id}
                  onClick={() => scrollTo(link.id)}
                  className="text-left px-6 py-4 text-base font-semibold text-[#0F293E] border-b border-gray-100 cursor-pointer hover:bg-gray-50"
                >
                  {link.label}
                </button>
              ))}
              <div className="p-6 mt-4">
                <button
                  onClick={() => scrollTo('solicitar-demo')}
                  className="btn-primary w-full text-center block"
                >
                  Cotizar Ahora
                </button>
              </div>
            </div> */}
          </div>
        </div>
      )}
    </>
  )
}

export default Navbar
